<template>
  <div class="sales-follow-table-wrap">
  <table class="sales-follow-table">
    <colgroup>
      <template v-for="col in tableColumns">
        <col :key="col.prop">
      </template>
    </colgroup>
    <thead>
      <tr>
        <th
          v-for="col in tableColumns"
          :key="col.prop"
          :class="col.className"
        >
          {{ col.label }}
        </th>
      </tr>
    </thead>
    <tbody class="group-tbody" v-if="showGroupSummary && hasGroupMetrics">
      <!-- 团队汇总部分 -->
      <tr>
        <!-- 要固定前面4列，所以最下面的统计部分只能从最左边列开始了。不然就得还加一列，固定前5列 但是没有合适的列加了 -->
        <td class="column-staff" :rowspan="13 + followKeyItemNames.length">团队销售报告</td>
        <td rowspan="2">业务员<br>跟进客户数量</td>
        <td>新</td>
        <td>
          <NumberFormatter :disabled="exportMode" :value="$get(groupData, 'followed_new_customers_count.common.total')" />
        </td>
        <td v-for="date in renderDates" :key="date" class="column-date" :class="[date, { 'is-today': date === todayDate }]">
          <NumberFormatter :disabled="exportMode" :value="$get(groupData, `followed_new_customers_count.common.${date}`)" />
        </td>
      </tr>
      <tr>
        <td>旧</td>
        <td>
          <NumberFormatter :disabled="exportMode" :value="$get(groupData, 'followed_customers_count.common.total')" />
        </td>
        <td v-for="date in renderDates" :key="date" class="column-date" :class="[date, { 'is-today': date === todayDate }]">
          <NumberFormatter :disabled="exportMode" :value="$get(groupData, `followed_customers_count.common.${date}`)" />
        </td>
      </tr>

      <!-- 客服 跟进客户数量 -->
      <tr>
        <td rowspan="2">客服经理<br>跟进客户数量</td>
        <td>新</td>
        <td>
          <NumberFormatter :disabled="exportMode" :value="$get(groupData, 'followed_new_customers_count.customer_service.total')" />
        </td>
        <td v-for="date in renderDates" :key="date" class="column-date" :class="[date, { 'is-today': date === todayDate }]">
          <NumberFormatter :disabled="exportMode" :value="$get(groupData, `followed_new_customers_count.customer_service.${date}`)" />
        </td>
      </tr>
      <tr>
        <td>旧</td>
        <td>
          <NumberFormatter :disabled="exportMode" :value="$get(groupData, 'followed_customers_count.customer_service.total')" />
        </td>
        <td v-for="date in renderDates" :key="date" class="column-date" :class="[date, { 'is-today': date === todayDate }]">
          <NumberFormatter :disabled="exportMode" :value="$get(groupData, `followed_customers_count.customer_service.${date}`)" />
        </td>
      </tr>

      <!-- 样板行 -->
      <tr>
        <td>样板</td>
        <td>新增</td>
        <td>
          <NumberFormatter :disabled="exportMode" :value="$get(groupData, 'new_product_designs_count.total')" />
        </td>
        <td v-for="date in renderDates" :key="date" class="column-date" :class="[date, { 'is-today': date === todayDate }]">
          <NumberFormatter :disabled="exportMode" :value="$get(groupData, `new_product_designs_count.${date}`)" />
        </td>
      </tr>

      <!-- 飞鸽订单行 -->
      <tr>
        <td>飞鸽订单</td>
        <td>新增</td>
        <td>
          <NumberFormatter :disabled="exportMode" :value="$get(groupData, 'new_feige_orders_count.total')" />
        </td>
        <td v-for="date in renderDates" :key="date" class="column-date" :class="[date, { 'is-today': date === todayDate }]">
          <NumberFormatter :disabled="exportMode" :value="$get(groupData, `new_feige_orders_count.${date}`)" />
        </td>
      </tr>

      <!-- 订单相关行 -->
      <tr>
        <td rowspan="2">订单</td>
        <td>下单数量</td>
        <td>
          <NumberFormatter :disabled="exportMode" :value="$get(groupData, 'new_sales_orders_quantity.total')" />
        </td>
        <td v-for="date in renderDates" :key="date" class="column-date" :class="[date, { 'is-today': date === todayDate }]">
          <NumberFormatter :disabled="exportMode" :value="$get(groupData, `new_sales_orders_quantity.${date}`)" />
        </td>
      </tr>
      <tr>
        <td>下单金额</td>
        <td>
          <NumberFormatter :disabled="exportMode" :value="$get(groupData, 'new_sales_orders_amount.total')" />
        </td>
        <td v-for="date in renderDates" :key="date" class="column-date" :class="[date, { 'is-today': date === todayDate }]">
          <NumberFormatter :disabled="exportMode" :value="$get(groupData, `new_sales_orders_amount.${date}`)" />
        </td>
      </tr>

      <!-- 出货相关行 -->
      <tr>
        <td rowspan="2">出货</td>
        <td>出货数量</td>
        <td>
          <NumberFormatter :disabled="exportMode" :value="$get(groupData, 'new_orders_quantity.total')" />
        </td>
        <td v-for="date in renderDates" :key="date" class="column-date" :class="[date, { 'is-today': date === todayDate }]">
          <NumberFormatter :disabled="exportMode" :value="$get(groupData, `new_orders_quantity.${date}`)" />
        </td>
      </tr>
      <tr>
        <td>出货金额</td>
        <td>
          <NumberFormatter :disabled="exportMode" :value="$get(groupData, 'new_orders_amount.total')" />
        </td>
        <td v-for="date in renderDates" :key="date" class="column-date" :class="[date, { 'is-today': date === todayDate }]">
          <NumberFormatter :disabled="exportMode" :value="$get(groupData, `new_orders_amount.${date}`)" />
        </td>
      </tr>

      <!-- 财务相关行 -->
      <tr>
        <td rowspan="3">财务</td>
        <td>回款</td>
        <td>
          <NumberFormatter :disabled="exportMode" :value="$get(groupData, 'payments_amount.total')" />
        </td>
        <td v-for="date in renderDates" :key="date" class="column-date" :class="[date, { 'is-today': date === todayDate }]">
          <NumberFormatter :disabled="exportMode" :value="$get(groupData, `payments_amount.${date}`)" />
        </td>
      </tr>
      <tr>
        <td class="color-primary">应收未收</td>
        <td>
          <NumberFormatter :disabled="exportMode" :value="$get(groupData, 'pending_payments_amount.total')" />
        </td>
        <td v-for="date in renderDates" :key="date" class="column-date" :class="[date, { 'is-today': date === todayDate }]">
          <NumberFormatter :disabled="exportMode" :value="$get(groupData, `pending_payments_amount.${date}`)" />
        </td>
      </tr>
      <tr>
        <td class="color-primary">应收逾期</td>
        <td>
          <NumberFormatter :disabled="exportMode" :value="$get(groupData, 'overdue_payments_amount.total')" />
        </td>
        <td v-for="date in renderDates" :key="date" class="column-date" :class="[date, { 'is-today': date === todayDate }]">
          <NumberFormatter :disabled="exportMode" :value="$get(groupData, `overdue_payments_amount.${date}`)" />
        </td>
      </tr>

      <!-- 关键事项行 -->
      <tr v-for="name in followKeyItemNames" :key="name">
        <td v-if="name === followKeyItemNames[0]" :rowspan="followKeyItemNames.length">关键事项</td>
        <td>{{ name }}</td>
        <td>
          <NumberFormatter :disabled="exportMode" :value="$get(groupData, `follow_key_items.${name}.total`)" />
        </td>
        <td v-for="date in renderDates" :key="date" class="column-date" :class="[date, { 'is-today': date === todayDate }]">
          <NumberFormatter :disabled="exportMode" :value="$get(groupData, `follow_key_items.${name}.${date}`)" />
        </td>
      </tr>

      <tr>
        <td></td>
        <td class="bg-primary" v-if="showFinishTarget">完结金额</td>
        <td class="bg-primary">下单金额</td>
        <td class="bg-primary">出货金额</td>
        <td class="bg-primary" v-if="showWholesaleAmount">批发总额</td>
        <td v-if="shouldRenderPerformanceGoalSpacer" :colspan="performanceGoalEmptyColspan" class="column-empty-spacer"></td>
      </tr>
      <tr>
        <td class="bg-primary">本月目标</td>
        <td v-if="showFinishTarget">
          <!-- 完结目标 -->
          <NumberFormatter :disabled="exportMode" :value="$get(groupPerformanceGoal, 'finish_target')" />
        </td>
        <td>
          <NumberFormatter :disabled="exportMode" :value="$get(groupPerformanceGoal, 'sales_target')" />
        </td>
        <td>
          <NumberFormatter :disabled="exportMode" :value="$get(groupPerformanceGoal, 'shipping_target')" />
        </td>
        <td v-if="showWholesaleAmount">
          /
        </td>
        <td v-if="shouldRenderPerformanceGoalSpacer" :colspan="performanceGoalEmptyColspan" class="column-empty-spacer"></td>
      </tr>
      <tr>
        <td class="bg-primary">实际完成</td>
        <td v-if="showFinishTarget">
          <!-- 完结金额 -->
          <NumberFormatter :disabled="exportMode" :value="$get(groupPerformanceGoal, 'finish_amount')" />
        </td>
        <td>
          <NumberFormatter :disabled="exportMode" :value="$get(groupPerformanceGoal, 'sales_amount')" />
        </td>
        <td>
          <NumberFormatter :disabled="exportMode" :value="$get(groupPerformanceGoal, 'shipping_amount')" />
        </td>
        <td v-if="showWholesaleAmount">
          <NumberFormatter :disabled="exportMode" :value="$get(groupPerformanceGoal, 'wholesale_amount')" />
        </td>
        <td v-if="shouldRenderPerformanceGoalSpacer" :colspan="performanceGoalEmptyColspan" class="column-empty-spacer"></td>
      </tr>
      <tr>
        <td class="bg-primary">团队完成率</td>
        <!-- 完结金额 完成率 -->
        <td v-if="showFinishTarget">
          {{ groupPerformanceGoal.finish_percent }}
        </td>
        <td>{{ groupPerformanceGoal.sales_percent }}</td>
        <td>{{ groupPerformanceGoal.shipping_percent }}</td>
        <td v-if="showWholesaleAmount">/</td>
        <td v-if="shouldRenderPerformanceGoalSpacer" :colspan="performanceGoalEmptyColspan" class="column-empty-spacer"></td>
      </tr>
      <tr>
        <td class="bg-primary">距离目标</td>
        <!-- 完结金额 距离目标 -->
        <td v-if="showFinishTarget">
          <NumberFormatter v-if="hasGroupMetrics" :disabled="exportMode" :value="groupPerformanceGoal.finish_diff" />
          <span v-else>-</span>
        </td>
        <td>
          <NumberFormatter v-if="groupPerformanceGoal.sales_diff > 0" :disabled="exportMode" :value="groupPerformanceGoal.sales_diff" />
          <span v-else-if="hasGroupMetrics">已达成</span>
          <span v-else>-</span>
        </td>
        <td>
          <NumberFormatter v-if="groupPerformanceGoal.shipping_diff > 0" :disabled="exportMode" :value="groupPerformanceGoal.shipping_diff" />
          <span v-else-if="hasGroupMetrics">已达成</span>
          <span v-else>-</span>
        </td>
        <td v-if="showWholesaleAmount">/</td>
        <td v-if="shouldRenderPerformanceGoalSpacer" :colspan="performanceGoalEmptyColspan" class="column-empty-spacer"></td>
      </tr>
    </tbody>
    <template v-for="(item, rowIndex) in renderedTableData">
      <tbody :key="item.user_id">
        <!-- 空行 -->
        <tr class="empty-tr" v-if="rowIndex > 0 || (rowIndex === 0 && showGroupSummary)">
          <td :colspan="tableColumns.length" class="row-spacer"></td>
        </tr>
        <tr>
          <td class="column-staff" :rowspan="14 + followKeyItemNames.length">{{ item.screen_name }}</td>
          <td rowspan="2">跟进客户数量</td>
          <td>新</td>
          <td class="column-summary">
            <NumberFormatter :disabled="exportMode" :value="$get(summaryKeyByUserId[item.user_id], 'followed_new_customers_count')" />
          </td>
          <td v-for="date in renderDates" :key="date" class="column-date" :class="[date, { 'is-today': date === todayDate }]">
            <NumberFormatter :disabled="exportMode" :value="$get(item, `followed_new_customers_count.${date}`)" />
          </td>
        </tr>
        <tr>
          <td>旧</td>
          <td  class="column-summary">{{ $get(summaryKeyByUserId[item.user_id], 'followed_customers_count') }}</td>
          <td v-for="date in renderDates" :key="date" class="column-date" :class="[date, { 'is-today': date === todayDate }]">
            <NumberFormatter :disabled="exportMode" :value="$get(item, `followed_customers_count.${date}`)" />
          </td>
        </tr>
        <tr>
          <td>样板</td>
          <td>新增</td>
          <td  class="column-summary">
            <NumberFormatter :disabled="exportMode" :value="$get(summaryKeyByUserId[item.user_id], 'new_product_designs_count')" />
          </td>
          <td v-for="date in renderDates" :key="date" class="column-date" :class="[date, { 'is-today': date === todayDate }]">
            <NumberFormatter :disabled="exportMode" :value="$get(item, `new_product_designs_count.${date}`)" />
          </td>
        </tr>
        <tr>
          <td>飞鸽订单</td>
          <td>新增</td>
          <td  class="column-summary">
            <NumberFormatter :disabled="exportMode" :value="$get(summaryKeyByUserId[item.user_id], 'new_feige_orders_count')" />
          </td>
          <td v-for="date in renderDates" :key="date" class="column-date" :class="[date, { 'is-today': date === todayDate }]">
            <NumberFormatter :disabled="exportMode" :value="$get(item, `new_feige_orders_count.${date}`)" />
          </td>
        </tr>

        <tr>
          <td rowspan="2">订单</td>
          <td>下单数量</td>
          <td  class="column-summary">
            <NumberFormatter :disabled="exportMode" :value="$get(summaryKeyByUserId[item.user_id], 'new_sales_orders_quantity')" />
          </td>
          <td v-for="date in renderDates" :key="date" class="column-date" :class="[date, { 'is-today': date === todayDate }]">
            <NumberFormatter :disabled="exportMode" :value="$get(item, `new_sales_orders_quantity.${date}`)" />
          </td>
        </tr>
        <tr>
          <td>下单金额</td>
          <td class="column-summary">
            <NumberFormatter :disabled="exportMode" :value="$get(summaryKeyByUserId[item.user_id], 'new_sales_orders_amount')" />
          </td>
          <td v-for="date in renderDates" :key="date" class="column-date" :class="[date, { 'is-today': date === todayDate }]">
            <NumberFormatter :disabled="exportMode" :value="$get(item, `new_sales_orders_amount.${date}`)" />
          </td>
        </tr>
        <tr>
          <td rowspan="2">出货</td>
          <td>出货数量</td>
          <td class="column-summary">
            <NumberFormatter :disabled="exportMode" :value="$get(summaryKeyByUserId[item.user_id], 'new_orders_quantity')" />
          </td>
          <td v-for="date in renderDates" :key="date" class="column-date" :class="[date, { 'is-today': date === todayDate }]">
            <NumberFormatter :disabled="exportMode" :value="$get(item, `new_orders_quantity.${date}`)" />
          </td>
        </tr>
        <tr>
          <td>出货金额</td>
          <td class="column-summary">
            <NumberFormatter :disabled="exportMode" :value="$get(summaryKeyByUserId[item.user_id], 'new_orders_amount')" />
          </td>
          <td v-for="date in renderDates" :key="date" class="column-date" :class="[date, { 'is-today': date === todayDate }]">
            <NumberFormatter :disabled="exportMode" :value="$get(item, `new_orders_amount.${date}`)" />
          </td>
        </tr>
        <!-- 财务相关行 -->
        <tr>
          <td rowspan="3">财务</td>
          <td>回款</td>
          <td class="column-summary">
            <NumberFormatter :disabled="exportMode" :value="$get(summaryKeyByUserId[item.user_id], 'payments_amount')" />
          </td>
          <td v-for="date in renderDates" :key="date" class="column-date" :class="[date, { 'is-today': date === todayDate }]">
            <NumberFormatter :disabled="exportMode" :value="$get(item, `payments_amount.${date}`)" />
          </td>
        </tr>
        <tr>
          <td class="color-primary">应收未收</td>
          <td class="column-summary">
            <NumberFormatter :disabled="exportMode" :value="$get(summaryKeyByUserId[item.user_id], 'pending_payments_amount')" />
          </td>
          <td v-for="date in renderDates" :key="date" class="column-date" :class="[date, { 'is-today': date === todayDate }]">
            <NumberFormatter :disabled="exportMode" :value="$get(item, `pending_payments_amount.${date}`)" />
          </td>
        </tr>
        <tr>
          <td class="color-primary">应收逾期</td>
          <td class="column-summary">
            <NumberFormatter :disabled="exportMode" :value="$get(summaryKeyByUserId[item.user_id], 'overdue_payments_amount')" />
          </td>
          <td v-for="date in renderDates" :key="date" class="column-date" :class="[date, { 'is-today': date === todayDate }]">
            <NumberFormatter :disabled="exportMode" :value="$get(item, `overdue_payments_amount.${date}`)" />
          </td>
        </tr>
        <!-- 关键事项行 -->
        <tr v-for="name in followKeyItemNames" :key="name">
          <td v-if="name === followKeyItemNames[0]" :rowspan="followKeyItemNames.length">关键事项</td>
          <td>{{ name }}</td>
          <td class="column-summary">
            <NumberFormatter :disabled="exportMode" :value="$get(summaryKeyByUserId[item.user_id], `follow_key_items.${name}`)" />
          </td>
          <td v-for="date in renderDates" :key="date" class="column-date" :class="[date, { 'is-today': date === todayDate }]">
            <NumberFormatter :disabled="exportMode" :value="$get(item, `follow_key_items_count.${name}.${date}`)" />
          </td>
        </tr>
        <tr>
          <td rowspan="3">工作报告</td>
          <td>当日内容</td>
          <td rowspan="3" class="column-summary">/</td>
          <td v-for="date in renderDates" :key="date" class="column-date" :class="[date, { 'is-today': date === todayDate }]">
            <template v-if="exportMode || showFullTextContent">
              <app-multiple-row-text :value="$get(item, `work_report_content.${date}`)" />
            </template>
            <template v-else>
              <div
                v-if="$get(item, `work_report_content.${date}`)"
                class="cell-link"
                @click="openTextDialog('工作报告', $get(item, `work_report_content.${date}`))"
              >
                查看
              </div>
            </template>
          </td>
        </tr>
        <tr>
          <td>次日计划</td>
          <td v-for="date in renderDates" :key="date" class="column-date" :class="[date, { 'is-today': date === todayDate }]">
            <template v-if="exportMode || showFullTextContent">
              <app-multiple-row-text :value="$get(item, `work_report_plan.${date}`)" />
            </template>
            <template v-else>
              <div
                v-if="$get(item, `work_report_plan.${date}`)"
                class="cell-link"
                @click="openTextDialog('次日计划', $get(item, `work_report_plan.${date}`))"
              >
                查看
              </div>
            </template>
          </td>
        </tr>
        <tr>
          <td>询盘内容</td>
          <td v-for="date in renderDates" :key="date" class="column-date" :class="[date, { 'is-today': date === todayDate }]">
            <template v-if="exportMode || showFullTextContent">
              <app-multiple-row-text :value="$get(item, `work_report_inquiry_content.${date}`)" />
            </template>
            <template v-else>
              <div
                v-if="$get(item, `work_report_inquiry_content.${date}`)"
                class="cell-link"
                @click="openTextDialog('询盘内容', $get(item, `work_report_inquiry_content.${date}`))"
              >
                查看
              </div>
            </template>
          </td>
        </tr>

      <tr>
        <td></td>
        <td class="bg-primary" v-if="showFinishTarget">完结金额</td>
        <td class="bg-primary">下单金额</td>
        <td class="bg-primary">出货金额</td>
        <td class="bg-primary" v-if="showWholesaleAmount">批发总额</td>
        <td v-if="shouldRenderPerformanceGoalSpacer" :colspan="performanceGoalEmptyColspan" class="column-empty-spacer"></td>
      </tr>
      <tr>
        <td class="bg-primary">本月目标</td>
        <td v-if="showFinishTarget">
          <!-- 完结目标 -->
          <NumberFormatter :disabled="exportMode" :value="$get(summaryKeyByUserId[item.user_id], 'performance_goal.finish_target')" />
        </td>
        <td>
          <NumberFormatter :disabled="exportMode" :value="$get(summaryKeyByUserId[item.user_id], 'performance_goal.sales_target')" />
        </td>
        <td>
          <NumberFormatter :disabled="exportMode" :value="$get(summaryKeyByUserId[item.user_id], 'performance_goal.shipping_target')" />
        </td>
        <td v-if="showWholesaleAmount">
          /
        </td>
        <td v-if="shouldRenderPerformanceGoalSpacer" :colspan="performanceGoalEmptyColspan" class="column-empty-spacer"></td>
      </tr>
      <tr>
        <td class="bg-primary">实际完成</td>
        <td v-if="showFinishTarget">
          <!-- 完结金额 -->
          <NumberFormatter :disabled="exportMode" :value="$get(summaryKeyByUserId[item.user_id], 'performance_goal.finish_amount')" />
        </td>
        <td>
          <NumberFormatter :disabled="exportMode" :value="$get(summaryKeyByUserId[item.user_id], 'performance_goal.sales_amount')" />
        </td>
        <td>
          <NumberFormatter :disabled="exportMode" :value="$get(summaryKeyByUserId[item.user_id], 'performance_goal.shipping_amount')" />
        </td>
        <td v-if="showWholesaleAmount">
          <NumberFormatter :disabled="exportMode" :value="$get(item, 'performance_goal.wholesale_amount')" />
        </td>
        <td v-if="shouldRenderPerformanceGoalSpacer" :colspan="performanceGoalEmptyColspan" class="column-empty-spacer"></td>
      </tr>
      <tr>
        <td class="bg-primary">完成率</td>
        <!-- 完结金额 完成率 -->
        <td v-if="showFinishTarget">
          {{ $get(summaryKeyByUserId[item.user_id], 'performance_goal.finish_percent') }}
        </td>
        <td>{{ $get(summaryKeyByUserId[item.user_id], 'performance_goal.sales_percent') }}</td>
        <td>{{ $get(summaryKeyByUserId[item.user_id], 'performance_goal.shipping_percent') }}</td>
        <td v-if="showWholesaleAmount">/</td>
        <td v-if="shouldRenderPerformanceGoalSpacer" :colspan="performanceGoalEmptyColspan" class="column-empty-spacer"></td>
      </tr>
      <tr>
        <td class="bg-primary">距离目标</td>
        <!-- 完结金额 距离目标 -->
        <td v-if="showFinishTarget">
          <NumberFormatter :disabled="exportMode" :value="$get(summaryKeyByUserId[item.user_id], 'performance_goal.finish_diff')" />
        </td>
        <td>
          <NumberFormatter v-if="$get(summaryKeyByUserId[item.user_id], 'performance_goal.sales_diff') > 0" :disabled="exportMode" :value="$get(summaryKeyByUserId[item.user_id], 'performance_goal.sales_diff')" />
          <span v-else>已达成</span>
        </td>
        <td>
          <NumberFormatter v-if="$get(summaryKeyByUserId[item.user_id], 'performance_goal.shipping_diff') > 0" :disabled="exportMode" :value="$get(summaryKeyByUserId[item.user_id], 'performance_goal.shipping_diff')" />
          <span v-else>已达成</span>
        </td>
        <td v-if="showWholesaleAmount">/</td>
        <td v-if="shouldRenderPerformanceGoalSpacer" :colspan="performanceGoalEmptyColspan" class="column-empty-spacer"></td>
      </tr>
      </tbody>
    </template>
  </table>

  <el-dialog
    :visible.sync="textDialogVisible"
    :title="textDialogTitle"
    append-to-body
    destroy-on-close
  >
    <app-multiple-row-text :value="textDialogContent" />
  </el-dialog>
  </div>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import moment from 'moment';
import LocaleString from '@/components/locale-string';

const DEFAULT_GROUP_PERFORMANCE_GOAL = Object.freeze({
  finish_target: 0,
  finish_amount: 0,
  finish_percent: '-',
  finish_diff: 0,
  sales_target: 0,
  sales_amount: 0,
  sales_percent: '-',
  sales_diff: 0,
  shipping_target: 0,
  shipping_amount: 0,
  shipping_percent: '-',
  shipping_diff: 0,
  wholesale_amount: 0,
});

const EMPTY_REPORT_METRICS = Object.freeze({
  dates: Object.freeze([]),
  summary: Object.freeze([]),
  summaryKeyByUserId: Object.freeze({}),
  groupData: Object.freeze({}),
  groupPerformanceGoal: DEFAULT_GROUP_PERFORMANCE_GOAL,
});

const NumberFormatter = {
  functional: true,
  render: (h, { props }) => {
    const { value, disabled = false } = props;
    if (disabled) {
      if (value === null || value === undefined || value === '') {
        return <span></span>;
      }
      const num = Number(value);
      if (Number.isNaN(num)) {
        return <span>{ value }</span>;
      }
      return <span>{ Number.isInteger(num) ? num : num.toFixed(2) }</span>;
    }
    return <LocaleString value={value} />;
  }
}

@Component({
  components: {
    NumberFormatter,
  }
})
export default class Table extends Vue {
  @Prop({ type: Array, default: () => [] }) data;
  @Prop({ type: [String, Number], default: '' }) userId;
  @Prop({ type: Boolean, default: false }) exportMode;
  @Prop({ type: String, default: '' }) roleKind;
  @Prop({ type: String, default: '' }) startOn;
  @Prop({ type: Boolean, default: false }) showFullTextContent;
  @Prop({ type: Boolean, default: false }) showGroupSummary;
  @Prop({ type: Boolean, default: false }) isReportMode;
  @Prop({ type: Array, default: () => [] }) users;
  @Prop({ type: Boolean, default: false }) showFinishTarget; // 是否显示完结金额那一列
  @Prop({ type: Boolean, default: false }) showWholesaleAmount; // 是否显示批发总额那一列
  @Prop({ type: Array, default: () => [] }) followKeyItemNames; // 关键事项名称列表
  @Prop({ type: Number, default: Number.POSITIVE_INFINITY }) userRenderLimit;
  @Prop({ type: Object, default: () => EMPTY_REPORT_METRICS }) reportMetrics;

  todayDate = moment().format('YYYY-MM-DD');
  textDialogVisible = false;
  textDialogTitle = '';
  textDialogContent = '';

  // 统计那部分后面的空列
  get performanceGoalColumnsEmptyColumns() {
    let columnLen = this.renderDates.length;
    const showNum = [this.showFinishTarget, this.showWholesaleAmount].filter(Boolean).length;
    if (showNum === 0) {
      columnLen += 1;
    } else if (showNum === 2) {
      columnLen -= 1;
    }
    return new Array(Math.max(columnLen, 0)).fill('');
  }

  get performanceGoalEmptyColspan() {
    return this.performanceGoalColumnsEmptyColumns.length;
  }

  get shouldRenderPerformanceGoalSpacer() {
    return this.performanceGoalEmptyColspan > 0;
  }

  get hasGroupMetrics() {
    return this.summary.length > 0;
  }

  get summary() {
    return this.reportMetrics.summary || EMPTY_REPORT_METRICS.summary;
  }

  get summaryKeyByUserId() {
    return this.reportMetrics.summaryKeyByUserId || EMPTY_REPORT_METRICS.summaryKeyByUserId;
  }

  // 团队数据
  get groupData() {
    return this.reportMetrics.groupData || EMPTY_REPORT_METRICS.groupData;
  }

  // 团队数据汇总
  get groupPerformanceGoal() {
    return this.reportMetrics.groupPerformanceGoal || EMPTY_REPORT_METRICS.groupPerformanceGoal;
  }

  get dates() {
    if (this.reportMetrics.dates && this.reportMetrics.dates.length) {
      return this.reportMetrics.dates;
    }

    const startDate = moment(this.startOn).startOf('month');
    const today = moment();
    const daysInMonth = startDate.daysInMonth();
    const dates = [];

    for (let i = 0; i < daysInMonth; i++) {
      const currentDate = moment(startDate).add(i, 'days');
      // 如果当前日期超过今天，就停止添加
      if (currentDate.isAfter(today)) {
        break;
      }
      dates.push(currentDate.format('YYYY-MM-DD'));
    }
    dates.reverse();
    return dates;
  }

  get renderDates() {
    if (this.isReportMode) {
      // 日报图片模式只显示今天
      return this.dates.filter(date => date === this.todayDate);
    }
    return this.dates;
  }

  get tableColumns() {
    return [
      {
        prop: 'user',
        label: '业务员',
        className: 'column-staff',
      },
      {
        prop: 'work_content',
        label: '工作内容',
        className: 'column-work-content',
      },
      {
        prop: 'items',
        label: '子项',
        className: 'column-items',
      },
      {
        prop: 'total',
        label: '合计',
        className: 'column-summary',
      },
      ...this.renderDates.map(date => ({
        prop: date,
        label: date,
        className: `column-date ${date === this.todayDate ? 'is-today' : ''}`,
      }))
    ]
  }

  get tableData() {
    if (!this.userId) {
      return this.isReportMode ? [] : this.data;
    }
    return this.data.filter(item => String(item.user_id) === String(this.userId));
  }

  get renderedTableData() {
    if (this.exportMode || this.isReportMode) {
      return this.tableData;
    }
    return this.tableData.slice(0, this.userRenderLimit);
  }

  openTextDialog(title, content) {
    this.textDialogTitle = title;
    this.textDialogContent = content;
    this.textDialogVisible = true;
  }
}
</script>

<style lang="scss" scoped>
.sales-follow-table-wrap {
  --table-column-width: 100px;
  --work-content-width: 100px;
  --sticky-staff-left: 0;
  --sticky-work-content-left: var(--table-column-width);
  --sticky-items-left: calc(var(--table-column-width) + var(--work-content-width));
  --sticky-summary-left: calc(var(--table-column-width) * 2 + var(--work-content-width));
  width: max-content;
}

.sales-follow-table {
  border-collapse: collapse;
  table-layout: fixed;
  border-top: 1px solid #ddd;
  font-family: 'Microsoft YaHei', "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", Arial, sans-serif;
  color: #292929;

  th, td {
    border: 1px solid #ddd;
    padding: 8px;
    text-align: center;
    overflow: hidden;
    width: 100px;
    min-width: 100px;
    max-width: 100px;
    background-color: #fff;
    vertical-align: middle;
  }

  th {
    background-color: #f0f0f0 !important;
    position: sticky;
    top: 0;
    z-index: 2;
    border-top: none;
  }

  .text-ellipsis {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }

  .cursor-pointer {
    cursor: pointer;
  }

  .cell-link {
    color: var(--primary-color);
    cursor: pointer;
    text-decoration: underline;
  }

  .row-spacer,
  .column-empty-spacer {
    border: none;
    background-color: transparent;
  }

  --primary-color: #3239c7;

  .color-primary {
    color: var(--primary-color);
  }

  .bg-primary {
    background-color: var(--primary-color);
    color: #fff;
  }

  .column-staff,
  .column-work-content,
  .column-items,
  .column-summary {
    position: sticky;
    background-color: #fff;
  }

  .column-staff {
    left: 0;
    z-index: 3;
  }

  .column-work-content {
    left: var(--sticky-work-content-left);
    z-index: 3;
  }

  .column-items {
    left: var(--sticky-items-left);
    z-index: 3;
  }

  .column-summary {
    left: var(--sticky-summary-left);
    z-index: 3;
  }

  th.column-staff,
  th.column-work-content,
  th.column-items,
  th.column-summary {
    z-index: 4;
    background-color: #f0f0f0 !important;
  }

  .column-staff:not(th) {
    word-break: break-all;
    color: var(--primary-color);
    font-weight: 500;
  }
}
</style>
